module.exports = __webpack_public_path__ + "static/media/answerPage2.f041312b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage2.png
// module id = 1724
// module chunks = 0 1